import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';

// ---- COMMON MODULES ---- //
import { Functions } from './functions';
import { TranslateService } from '@ngx-translate/core';
import { UserdataModel } from '../providers/userdata-model';
import { GameModel } from '../providers/game-model';
import { GamerulesModel } from '../providers/gamerules-model';
import { SmartAudio } from '../providers/smart-audio';
import { LoginPage } from '../pages/login/login'; 

/* This provider manages data exchange with the js server */

@Injectable()
export class DataExchanger {
  errorMessage: string;
  serverurl: string;

  constructor(public functions: Functions, public smartAudio: SmartAudio, public translate: TranslateService, public userdataModel:UserdataModel, public http: Http, public playModel: GameModel, public gamesrulesModel: GamerulesModel) {
    this.serverurl=this.functions.getServerUrl();
  }

  addOutGameBonusPointToScoreAndAdjustLevel(bonusScore){
    this.userdataModel.setScore(this.userdataModel.getScore()+bonusScore);
    this.userdataModel.setLevel(this.gamesrulesModel.getLevelFromScore(this.userdataModel.getScore()+bonusScore));
    this.setUpdatedUserScoreAndLvl(this.userdataModel.getScore()+bonusScore,this.gamesrulesModel.getLevelFromScore(this.userdataModel.getScore()+bonusScore));
  }

  getUserPwForStartOver(){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = {};

      this.http.post(this.serverurl+"/getuserpwforstartover", postParams, options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);
          
          resolve(obj);
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("getUserPwForStartOver",error);
        });
    });
  } 
 
  getEmptyBooksinfo(){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = {};

      this.http.post(this.serverurl+"/getemptybooksinfo", postParams, options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);
          
          resolve(obj);
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("getEmptyBooksinfo",error);
        });
    });
  } 


  setUpdatedUserScoreAndLvl(updatedScore,updateLvl){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = {
        score: updatedScore,
        level: updateLvl,
        guidUser: this.userdataModel.getGuidUser()
      };
      
      this.http.post(this.serverurl+"/setUpdatedUserScoreAndLvl", postParams, options)
        .subscribe(data => {
          resolve("setUpdatedUserScoreAndLvlOK");
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("setUpdatedUserScoreAndLvl",error);
      });
    });
  }

  setDataGameWinVersusPVPAsync(idGameToSetStatus,guidUserGameToSetStatus,win){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = {
        idGameToSetStatus: idGameToSetStatus,
        guidUserGameToSetStatus: guidUserGameToSetStatus,
        win:win
      };
      
      this.http.post(this.serverurl+"/setDataGameWinVersusPVPAsync", postParams, options)
        .subscribe(data => {
          resolve("setDataGameWinVersusPVPAsyncOK");
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("setDataGameWinVersusPVPAsync",error);
      });
    });
  }

  setDataGameStatusVersusPVPAsync(idGameToSetStatus,guidUserGameToSetStatus,status){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = {
        idGameToSetStatus: idGameToSetStatus,
        guidUserGameToSetStatus: guidUserGameToSetStatus,
        status:status
      };
      
      this.http.post(this.serverurl+"/setDataGameStatusVersusPVPAsync", postParams, options)
        .subscribe(data => {
          resolve("setDataGameStatusVersusPVPAsyncOK");
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("setDataGameAcceptedInGameSentVersusPVPAsync",error);
      });
    });
  }

  setDataGameAcceptedInGameSentVersusPVPAsync(idGameSent,guidUser,idGameAccepted){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = {
        idGameSent: idGameSent,
        guidUser: guidUser,
        idGameAccepted: idGameAccepted,
      };
      
      this.http.post(this.serverurl+"/setDataGameAcceptedInGameSentVersusPVPAsync", postParams, options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);
          //console.log("GAMESDATA PVP ASYNC: "+JSON.stringify(this.playModel.getWholeGamesDataPVPAsync()));
          resolve(obj);
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("setDataGameAcceptedInGameSentVersusPVPAsync",error);
      });
    });
  }

  getVersusPVPAsyncGames(){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = {
        guidUser: this.userdataModel.getGuidUser()
      };
      
      this.http.post(this.serverurl+"/getVersusPVPAsyncGames", postParams, options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);
          this.playModel.setWholeGamesDataPVPAsync(obj);
          //console.log("GAMESDATA PVP ASYNC: "+JSON.stringify(this.playModel.getWholeGamesDataPVPAsync()));
          resolve(obj);
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("getVersusPVPAsyncGames",error);
      });
    });
  }

  getVersusPVPSyncGames(){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = {
        guidUser: this.userdataModel.getGuidUser()
      };
      
      this.http.post(this.serverurl+"/getVersusPVPSyncGames", postParams, options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);
          this.playModel.setWholeGamesDataPVPSync(obj);
          //console.log("GAMESDATA PVP SYNC: "+JSON.stringify(this.playModel.getWholeGamesDataPVPSync()));
          resolve(obj); 
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("getVersusPVPSyncGames",error);
      });
    });
  }

  chooseRandomPlayer(){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = {
        guidSelf: this.userdataModel.getGuidUser()
      };
      
      this.http.post(this.serverurl+"/chooseRandomPlayer", postParams, options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);
          
          resolve(obj);
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("chooseRandomPlayer",error);
        });
    });
  }

  checkIfPlayerExistFromUsername(usernamePlayerToCheckExistence){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = {
        usernamePlayerToCheckExistence: usernamePlayerToCheckExistence
      };

      this.http.post(this.serverurl+"/checkIfPlayerExistFromUsername", postParams, options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);
          
          resolve(obj);
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("checkIfPlayerExistFromUsername",error);
        });
    });
  }

  getCollectibles(){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = {
        guidUser: this.userdataModel.getGuidUser()
      };

      this.http.post(this.serverurl+"/getcollectibles", postParams, options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);
          
          resolve(obj);
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("getCollectible",error);
        });
    });
  }

  getChunkForPVPgame(guidUserPlrOne,guidUserPlrTwo,idBook){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = {
        guidUserPlrOne: guidUserPlrOne,
        guidUserPlrTwo: guidUserPlrTwo,
        idBook: idBook
      };

      this.http.post(this.serverurl+"/getChunkForPVPgame", postParams, options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);
          
          resolve(obj);
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("getChunkForPVPgame",error);
        });
    });
  }

  getTimesChunkWasPlayedPVP(guidUser,idChunk,idBook){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = {
        guidUser: guidUser,
        idChunk: idChunk,
        idBook: idBook
      };

      this.http.post(this.serverurl+"/getTimesChunkWasPlayedPVP", postParams, options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);
          
          resolve(obj);
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("getTimesChunkWasPlayedPVP",error);
        });
    });
  }

  getSingleGameForVersus(guidUser,idGame,idBook,gamemode,language,challengerIsAI){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = {
        guidUserRequesting: this.userdataModel.getGuidUser(),
        guidUser: guidUser,
        idGame: idGame,
        idBook: idBook,
        gamemode: gamemode,
        language: language,
        challengerIsAI: challengerIsAI
      };

      this.http.post(this.serverurl+"/getSingleGameForVersus", postParams, options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);
          
          resolve(obj);
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("getSingleGameForVersus",error);
        });
    });
  }

  getSingleGameAIdataToCompareExchanger(guidUser,idBook,chunkStart){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = {
        guidUser: guidUser,
        idBook: idBook,
        chunkStart: chunkStart
      };

      this.http.post(this.serverurl+"/getSingleGameAIdataToCompare", postParams, options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);
          
          resolve(obj[0]);
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("getSingleGameAIdataToCompare",error);
        });
    });
  }

  getMaxAttemptsWrongFromServer(beginSlicedTexblock,endSlicedTexblock){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = {
        guidUser: this.userdataModel.getGuidUser(),
        idBook:this.functions.getIdCurrentBook(),
        startBookmark: beginSlicedTexblock,
        endBookmark: endSlicedTexblock,
        timesWasPlayed: this.userdataModel.getTimesWasPlayed()
      };

      
      this.http.post(this.serverurl+"/getMaxAttemptsWrong", postParams, options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);
          
          resolve(obj);
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("getRankingsFromServer",error);
        });
    });
  }

  getRankingsFromServer(){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = [];
      
      this.http.post(this.serverurl+"/getrankings", postParams, options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);

          resolve(obj);
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("getRankingsFromServer",error);
        });
    });
  }

  getRankingsAttemptsFromServer(){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = [];
      
      this.http.post(this.serverurl+"/getrankingsattempts", postParams, options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);

          resolve(obj);
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("getRankingsAttemptsFromServer",error);
        });
    });
  }

  getRankingsAverageEntropyFromServer(){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = [];
      
      this.http.post(this.serverurl+"/getrankingsaverageentropy", postParams, options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);

          resolve(obj);
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("getRankingsAverageEntropyFromServer",error);
        });
    });
  }

  getGamesDataFromServer(){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = this.userdataModel.userdata;
      // if this parameter is true, the game downloads a selection of games, otherwise downloads all
      postParams[0].gamesDataMinimized=true;
      
      this.http.post(this.serverurl+"/getgamesdata", postParams, options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);
          this.playModel.setWholeGamesData(obj);
          console.log("GAMESDATA: "+JSON.stringify(this.playModel.getWholeGamesData()));
          this.playModel.storeGamesData().then((response)=>{
            resolve("getGamesdataFromServerIsOk");
          });
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("getGamesdataFromServer",error);
      });
    });
  }

  getGamesrulesDataFromServer(){
    return new Promise((resolve) =>{
      this.getChunksDataFromServer().then((response)=>{
        //this.getScoreParDataFromServer().then((response)=>{
            this.getCollectiblesDataFromServer().then((response)=>{
              resolve("getGamesrulesdataFromServerIsOk");
            });
        //});
      });
    });
  }

  getCollectiblesDataFromServer(){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = this.userdataModel.userdata;
      
      this.http.post(this.serverurl+"/getcollectiblesdata", postParams, options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);
          this.gamesrulesModel.setWholeCollectiblesData(obj);
          //console.log("COLLECTIBLESDATA: "+JSON.stringify(this.gamesrulesModel.getWholeCollectiblesData()));
          this.gamesrulesModel.storeCollectiblesData().then((response)=>{
            resolve("getCollectiblesDataFromServerIsOk");
          });
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("getCollectiblesDataFromServer",error);
      });
    });
  }

  getChunksDataFromServer(){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = this.userdataModel.userdata;
      
      this.http.post(this.serverurl+"/getchunksdata", postParams, options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);
          this.gamesrulesModel.setWholeChunksData(obj);
          //console.log("CHUNKPARDATA: "+JSON.stringify(this.gamesrulesModel.getWholeChunksData()));
          this.gamesrulesModel.storeChunksData().then((response)=>{
            resolve("getChunksDataFromServerIsOk");
          });
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("getChunksDataFromServer",error);
      });
    });
  }

  /* getScoreParDataFromServer download all par data at the beginning of the game (see getGamesrulesDataFromServer)
  Now is not used for it has been considered better to download par data at the beginning of the game from server
  in order not to load eccessively browser storage for data are a lot (consider to use it if par data are less)
  */
  getScoreParDataFromServer(){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = this.userdataModel.userdata;
      
      this.http.post(this.serverurl+"/getscorepardata", postParams, options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);
          this.gamesrulesModel.setWholeScoreParData(obj);
          //console.log("SCOREPARDATA: "+JSON.stringify(this.gamesrulesModel.getWholeScoreParData()));
          this.gamesrulesModel.storeScoreParData().then((response)=>{
            resolve("getScoreParDataFromServerIsOk");
          });
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("getScoreParDataFromServer",error);
      });
    });
  }

  getScoreParDataofTextblockFromServer(idBook,startBookmark,endBookmark){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }
      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = {
        idBook: idBook,
        startBookmark: startBookmark,
        endBookmark: endBookmark
      };
      
      this.http.post(this.serverurl+"/getscorepardataoftextblock", postParams, options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);
          this.gamesrulesModel.setWholeScoreParData(obj);
          //console.log("SCOREPARDATAofTextblock: "+JSON.stringify(this.gamesrulesModel.getWholeScoreParData()));
          this.gamesrulesModel.storeScoreParData().then((response)=>{
            resolve("getScoreParDataofTextblockFromServerIsOk");
          });
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("getScoreParDataofTextblockFromServer",error);
      });
    });
  }

   getUserGameDataFromServer(){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = this.userdataModel.userdata;
      
      this.http.post(this.serverurl+"/getusergamesdata", postParams, options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);

          if(obj[0]){
            obj=obj[0];
          }
          
          var usergamedata=[];
          if(!obj.score || obj.score==-1){ usergamedata[0]=this.functions.emptyScore; }else{ usergamedata[0]=obj.score;}
          if(!obj.level || obj.level==-1){ usergamedata[1]=this.functions.emptyLevel; }else{ usergamedata[1]=obj.level;}
          // Here numberOfLogin is incremented. This works for getUserGameDataFromServer is done only at login time
          if(!obj.numberOfLogin || obj.numberOfLogin==-1){ usergamedata[8]=this.functions.emptyNumberOfLogin; usergamedata[8]++; }else{ usergamedata[8]=obj.numberOfLogin; usergamedata[8]++;}
          if(!obj.collectiblesGot || obj.collectiblesGot==''){ usergamedata[2]=this.functions.emptyCollectibles; }else{ usergamedata[2]=JSON.parse(obj.collectiblesGot);}
          
          // Booksinfo start with the default empty ones and elements are substituded with that of the user
          // if available. This allow to add books to the game without touching the db. Booksinfo will be
          // updated at the first login of the user
          usergamedata[3]=this.functions.emptyBooksinfo;
          if (obj.booksinfo) {
            var booksinfoUser=JSON.parse(obj.booksinfo);
            var numBook=1;
            for(var i=0; i<=booksinfoUser.length-1; i++) {
              numBook=i+1;
              if(booksinfoUser[i].book==numBook){
                usergamedata[3][i]=booksinfoUser[i];
              }
            }
          }
          
          if(!obj.settingsCurrentGamemode || obj.settingsCurrentGamemode==''){ usergamedata[4]=this.functions.emptySettingsCurrentGamemode; }else{ usergamedata[4]=obj.settingsCurrentGamemode;}
          if(!obj.settingsCurrentLanguage || obj.settingsCurrentLanguage==''){ usergamedata[5]=this.functions.emptySettingsCurrentLanguage; }else{ usergamedata[5]=obj.settingsCurrentLanguage;}
          // If this is the first login, take the language from the setting given during registration
          if (usergamedata[8]==1) {
            usergamedata[5]=this.userdataModel.getLanguage();
          }
          if(!obj.settingsCurrentSoundEffectStatus || obj.settingsCurrentSoundEffectStatus==-1){ usergamedata[6]=this.functions.emptySettingsCurrentSoundEffectStatus; }else{ usergamedata[6]=obj.settingsCurrentSoundEffectStatus;}
          if(!obj.settingsCurrentMusicVolume || obj.settingsCurrentMusicVolume==-1){ usergamedata[7]=this.functions.emptySettingsCurrentMusicVolume; }else{ usergamedata[7]=obj.settingsCurrentMusicVolume;}
          if(!obj.settingsCurrentCatChosen || obj.settingsCurrentCatChosen==-1){ usergamedata[9]=this.functions.emptySettingsCurrentCatChosen; }else{ usergamedata[9]=obj.settingsCurrentCatChosen;}

          this.userdataModel.setUserdata(
            "","","","","","","","","","","","","","","","","",
            usergamedata[0],usergamedata[1],usergamedata[8],usergamedata[2],usergamedata[3],usergamedata[4],
            usergamedata[5],usergamedata[6],usergamedata[7],usergamedata[9],
            "","","").then((response)=>{
              this.functions.gamemode=this.userdataModel.getSettingsCurrentGamemode().toString();
              this.functions.setGameMode();
              this.functions.language=this.userdataModel.getSettingsCurrentLanguage().toString();
              this.functions.setLanguage();
              this.smartAudio.soundEffectIsActive=Number(this.userdataModel.getSettingsCurrentSoundEffectStatus());
              this.functions.setSoundEffectIsActive();
              this.smartAudio.volume=Number(this.userdataModel.getSettingsCurrentMusicVolume());
              this.functions.setVolume();
              this.functions.catChosen=this.userdataModel.getSettingsCurrentCatChosen().toString();
              this.functions.setCatChosen();
              resolve("getUserGameDataFromServerIsOk");
            });

        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("getUserGameDataFromServer",error);
        });
    });
  }

  getTextblockFromServer(){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      var dataToSend = this.userdataModel.userdata; // level is inside userdata
      dataToSend[0].language= this.functions.language;
      let postParams = dataToSend;
      
      this.http.post(this.serverurl+"/gettextblock", postParams, options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);
          this.functions.currentTextblock=obj;
          resolve("getTextblockFromServerIsOk");
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("getTextblockFromServer",error);
      });
    });
    
  }

  storeUserGamedataOnServer(areSettingsChanged){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = {
        guidUser: this.userdataModel.getGuidUser(),
        score:this.userdataModel.getScore(),
        level:this.userdataModel.getLevel(),
        collectiblesGot:JSON.stringify(this.userdataModel.getCollectiblesGot()),
        booksinfo:JSON.stringify(this.userdataModel.getBooksinfo()),
        settingsCurrentGamemode:this.userdataModel.getSettingsCurrentGamemode(),
        settingsCurrentLanguage:this.userdataModel.getSettingsCurrentLanguage(),
        settingsCurrentSoundEffectStatus:this.userdataModel.getSettingsCurrentSoundEffectStatus(),
        settingsCurrentMusicVolume:this.userdataModel.getSettingsCurrentMusicVolume(),
        settingsCurrentCatChosen:this.userdataModel.getSettingsCurrentCatChosen(),
        areSettingsChanged: areSettingsChanged
      };
      
      this.http.post(this.serverurl+"/storeusergamesdata", postParams, options)
        .subscribe(data => {
          //let obj = JSON.parse(data['_body']);
          resolve("storeUserGamedataOnServerIsOk");
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("storeusergamesdata",error);
      });
    });
  }

  storeGamedataOnServer(){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = this.playModel.getLastGameData();

      console.log
      
      this.http.post(this.serverurl+"/storegamedata", postParams, options)
        .subscribe(data => {
          //let obj = JSON.parse(data['_body']);
          resolve("storeGamedataOnServerIsOk");
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("storeGamedataOnServer",error);
      });
    });
  }
  
  storeUserDataOnServer(){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = this.userdataModel.userdata;
      
      this.http.post(this.serverurl+"/storeuserdata", postParams, options)
        .subscribe(data => {
          //let obj = JSON.parse(data['_body']);
          resolve("storeUserDataOnServerIsOk");
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("storeUserDataOnServer",error);
      });
    });
  }

  setErrorMessage(callType, error){
    //TODO sistemare error messages and copy function from auth.js
    /*this.errorMessages.push("yea");
    this.errorMessages.push("yea2");
    console.log(this.errorMessages);*/
    var responseString:string;
    this.errorMessage="";
    responseString=error.toString();
    if(callType=="registration"){
      if(responseString.indexOf('Wrong username or password')!=-1){
        this.translate.get('userPwdWrong').subscribe(value => { this.errorMessage += value;});
      }
      if(responseString.indexOf('is already taken')!=-1){
        this.translate.get('nameTaken').subscribe(value => { this.errorMessage += value;});
      }
      if(responseString.indexOf('is already registered')!=-1){
        this.translate.get('emailTaken').subscribe(value => { this.errorMessage += value;});
      }
      if(this.errorMessage!=""){
        return;
      }
      
      this.translate.get('genericErrorMessage').subscribe(value => { this.errorMessage = value;});
      return;
    }
    if(callType=="login"){
      this.translate.get('genericErrorMessage').subscribe(value => { this.errorMessage = value;});
      return;
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/data-exchanger.ts